<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">
                <div class="px-4 pt-2 pb-2">
                    <PageHeader :title="titleModule" :icon="headerIcon" :help="headerHelp">
                        <template v-slot:primary>
                            <v-btn small dark color="primary" @click="checkIfHasSucursal" v-if="!showInventory">
                                <v-icon left>fas fa-plus-square</v-icon>{{ $vuetify.breakpoint.xsOnly ? 'Nueva' : 'Nueva entrada' }}
                            </v-btn>
                        </template>
                    </PageHeader>
                    <EntradaFilters :search.sync="search" :start.sync="datesRange.start" :end.sync="datesRange.end"
                        :provider-id.sync="filterProviderId" :providers="proveedores"
                        :pending.sync="filterPending" :inventory.sync="filterInventory"
                        :lock-inventory="showInventory" :total="totalItems" @search="searchListaEntrada"
                        :advanced.sync="advanced" :catalogs="filterCatalogs"
                        :advanced-count="advancedCount" @open-advanced="drawerFilters = true">
                        <template v-slot:tools>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon :small="!$vuetify.breakpoint.xsOnly" v-bind="attrs" v-on="on" aria-label="Actualizar" @click="reload()">
                                        <v-icon small>fas fa-sync</v-icon>
                                    </v-btn>
                                </template>
                                <span>Actualizar</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon :small="!$vuetify.breakpoint.xsOnly" v-bind="attrs" v-on="on" aria-label="Reporte de entradas" @click="handleExcelExport">
                                        <v-icon small>fas fa-file-export</v-icon>
                                    </v-btn>
                                </template>
                                <span>Reporte de entradas</span>
                            </v-tooltip>
                            <span class="columns-btn-fix"><Columns :headers.sync="headers"></Columns></span>
                        </template>
                    </EntradaFilters>
                </div>
                <v-data-table dense :headers="filteredHeaders" :items="lstEntrada" class="elevation-2"
                :loading="loading" loading-text="Cargando... espera un momento" :options.sync="options"
                :footer-props="{ 'items-per-page-options': [ 25, 50, 100 ],
                    showFirstLastPage: true,
                    firstIcon: 'fas fa-angle-double-left',
                    lastIcon: 'fas fa-angle-double-right',
                    prevIcon: 'fas fa-angle-left',
                    nextIcon: 'fas fa-angle-right'
                }"
                :single-expand="singleExpand" :expanded.sync="expanded" show-expand
                :server-items-length="totalItems">
                    <!-- group-by="producto.nombre"  -->
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="pa-0">
                            <EntryDetail :item="item"></EntryDetail>
                        </td>
                    </template>
                    <template v-slot:[`item.tipoEntrada`]="{ item }">
                        <strong :class="getColorByTypeEntry(item.tipoEntrada)">{{item.tipoEntrada}}</strong>
                    </template>
                    <template v-slot:[`item.prioridad`]="{ item }">
                        <v-chip :color="getColorPriority(item.prioridad)" dark label small text-color="black">
                            <v-avatar left>
                                <v-icon small>fas fa-exclamation</v-icon>
                                <strong class="text-h6 font-weight-bold">{{ item.prioridad }}</strong>
                            </v-avatar>
                        </v-chip>
                    </template>
                    <template v-slot:[`item.merma`]="{ item }">
                        <strong :class="item.merma > 0 ? 'red--text text--lighten-1 text-h6' : 'green--text text--lighten-1 text-h7 '">{{item.merma}}</strong>
                    </template>
                    <template v-slot:[`item.venta`]="{ item }">
                        <strong class="green--text text--lighten-1 text-h6">{{item.venta}}</strong>
                    </template>
                    <template v-slot:[`item.existencia`]="{ item }">
                        <strong :class="item.existencia == 0 ? 'red--text text--lighten-1 text-h6' : 'green--text text--lighten-1 text-h7 '">{{item.existencia}}</strong>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                       <ActionsEntrada :item="item" :editEntry="editEntry" :updatePrice="updatePrice"></ActionsEntrada>
                    </template>
                    <template v-slot:[`item.activo`]="{ item }">
                        <v-chip :color="colorStatus(item)" label dark x-small
                        v-text="statusEntrada(item)">
                        </v-chip>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
        <EntradaFilterDrawer v-model="drawerFilters" :filters="advanced" @apply="advanced = $event"
            :products="productos" :sucursales="sucursales" :tipo-entrada="tipoEntrada" :show-sucursal="canFilterSucursal">
        </EntradaFilterDrawer>
        <ModalNuevaEntrada :dialog.sync="dialog" :initialize.sync="initTableEntrada" :sucursales.sync="sucursales" :tipoEntrada.sync="filterTipoEntrada"
        :proveedores.sync="proveedores" :tipoPagos.sync="tipoPagos" :monedas.sync="monedas" :productos.sync="productos"
        :mode.sync="mode"
        :handleModal="handleModal" v-if="dialog" :entradaId.sync="entradaId">
        </ModalNuevaEntrada>
        <ExcelExportEntryDetail :dialog.sync="dialogEntryReportExcel" :handleModal="handleExcelExport"
        :typeEntry.sync="tipoEntrada" :providers.sync="proveedores"
        :brands.sync="sucursales" :is-admin="isAdmin" v-if="dialogEntryReportExcel"/>
    </v-row>
</template>
<script>
import SucursalDataService from '@/service/catalogo/sucursal/sucursalDataService';
import TipoEntradaService from '@/service/entrada/TipoEntradaService';
import ProveedorDataService from '@/service/catalogo/proveedor/proveedorDataService';
import TipoPagoDataService from '@/service/catalogo/tipoPago/tipoPagoDataService';
import MonedaDataService from '@/service/catalogo/tipoMoneda/tipoMonedaDataService';
import ProductoDataService from "@/service/producto/ProductoDataService";
import EntradaDetalleDataService  from '@/service/entrada/EntradaDetalleDataService'

import serverTableMixin from '@/mixins/serverTableMixin';
import ModalNuevaEntrada from './NuevaEntrada.vue'
import ActionsEntrada from './ActionsEntrada.vue';
import PageHeader from '@/components/shared/PageHeader.vue';
import EntradaFilters from './EntradaFilters.vue';
import EntradaFilterDrawer from './EntradaFilterDrawer.vue';
import { emptyAdvanced, advancedParams, countAdvanced } from './entradaFilters';
import Columns from '@/components/shared/Columns.vue';
import ExcelExportEntryDetail from './ExcelExportEntryDetail.vue';
import UsuarioDataService from '@/service/usuario/UsuarioDataService';
import EntryDetail from './EntryDetail.vue';
import { extractMessage } from '@/helpers/errorHelper';
import { can, CAP } from '@/service/permiso/capacidades';

export default {
    name: "ListaEntrada",
    mixins: [serverTableMixin],
    components: { ModalNuevaEntrada, PageHeader, EntradaFilters, EntradaFilterDrawer, ActionsEntrada, ExcelExportEntryDetail, Columns, EntryDetail },
    created() {
        this.getAllSucursal();
        this.getAllTipoEntrada();
        this.getProveedores();
        this.getAllTipoPago();
        this.getMoneda();
        this.getAllProducto();
        this.fetchTableData();
    },
    props: {
        proveedorId: { type: Number, default: null },
        typeEntry: { type: String, default: '' },
        showInventory: { type: Boolean, default: false },
    },
    data() {
        return {
            sucursales : [],
            tipoEntrada: [],
            proveedores: [],
            tipoPagos: [],
            monedas: [],
            productos: [],
            datesRange:{ start: '', end: '' },
            // Filtros que llegan de la ruta (props) y que el usuario puede cambiar.
            filterProviderId: this.proveedorId,
            filterPending: this.typeEntry === 'pending',
            filterInventory: this.showInventory,
            // Filtros del panel lateral: se aplican de una vez desde el panel.
            advanced: emptyAdvanced(),
            drawerFilters: false,
            lstEntrada: [],
            // Busca solo 500 ms después de la última tecla (Enter sigue funcionando)
            searchDebounceMs: 500,

            dialog: false,
            expanded: [],
            singleExpand: true,
            headers: [
                { text: "Acciones", value: "actions", sortable: false, groupable: false, show: true },
                { text: "ID", align: " d-none", sortable: false, value: "id", show: false, groupable: false },
                { text: "Folio entrada", value: "ticketFolio", groupable: false, show: true },
                { text: "Fecha entrada", value: "fechaEntrada", groupable: false, show: true },
                { text: "Tipo entrada", value: "tipoEntrada", groupable: false, show: true },
                { text: 'Sucursal', value:'sucursalRecibe', groupable: false, show: true },
                { text: "Prioridad", value: "prioridad", groupable: false, show: true },
                { text: "Producto", value: "producto.nombre", sortable: false, show: true },
                { text: "Ingreso", value: "cantidad", align: "end", groupable: false, show: true },
                // { text: "Entrada por traspaso", value: "totalEntradaTraspaso" },
                { text: "Salida traspaso", value: "totalSalidaTraspaso", align: "end", groupable: false, show: true },
                { text: "Mermas", value: "merma", align: "end", groupable: false, show: true },
                { text: "Ventas", value: "totalSalida", align: "end", groupable: false, show: true },
                { text: 'Existencia', value: 'existencia', align: 'end', groupable: false, show: true },
                { text: 'Peso promedio', value: 'averageWeight', align: 'end', groupable: false, show: false },
                { text: 'Peso neto', value: 'netWeight', align: 'end', groupable: false, show: false },
                { text: "Activo", value: "activo", groupable: false, show: true },
                { text: 'Tipo pago', value: 'tipoPago', groupable: false, show: false },
                { text: 'Proveedor', value: 'proveedor.nombre', groupable: false, show: false },
            ],
            // Entry report
            dialogEntryReportExcel: false,
            entradaId: null,
            mode: 'add',
        }
    },
    watch: {
        // Navegar entre Entradas, Inventario y las entradas de un proveedor
        // reutiliza este componente: solo cambian las props, así que hay que
        // volver a copiarlas a los filtros. Un solo watcher para las tres:
        // con uno por prop, cada una cambiaba un filtro por separado y la
        // tabla consultaba una vez por cada una.
        routeFilters() {
            this.filterProviderId = this.proveedorId;
            this.filterPending = this.typeEntry === 'pending';
            this.filterInventory = this.showInventory;
        },
    },
    methods: {
        searchListaEntrada(){
            this.doSearch();
        },
        fetchTable(params){
            return EntradaDetalleDataService.getEntradaDetalleTable( params );
        },
        applyRows({ rows, total }){
            this.lstEntrada = rows;
            this.totalItems = total;
        },
        // Callback que reciben los diálogos de alta y edición.
        initTableEntrada(){
            this.reload();
        },
        editEntry( { entrada } ){
            this.entradaId = entrada.id;
            this.dialog = true
            this.mode = 'edit'
        },
        updatePrice( { entrada } ){
            this.entradaId = entrada.id;
            this.dialog = true
            this.mode = 'updatePrice'
        },
        colorStatus( item ){
            if(item.eliminado) return 'red';
            return (item.status || item.existencia > 0 ) ? 'green darken-3' : 'grey';
        },
        statusEntrada( item ){
            if (item.eliminado) return 'Cancelado';
            return (item.status || item.existencia > 0 ) ? 'Activo' : 'Inactivo';
        },
        getColorPriority( prioridad ){
            const colourPriority = { 1: 'green', 2: 'yellow', 3: 'warning', 4: 'blue' };
            return colourPriority[prioridad] || 'grey';
        },
        getColorByTypeEntry( type ){
            const colourPriority = { 'Compra': 'blue--text', 'Traspaso': 'green--text', 'Proceso': 'orange--text' };
            const color = colourPriority[type] || 'grey--text';
            // el tono oscuro se pierde sobre fondo oscuro: en ese tema se aclara
            const shade = this.$vuetify.theme.dark ? 'text--lighten-2' : 'text--darken-4';
            return `${color} ${shade} font-weight-bold`;
        },
        async getAllSucursal(){
            this.sucursales = await SucursalDataService.lstSucursal().then( rsp => rsp.data ) || [];
        },
        async getAllTipoEntrada(){
            this.tipoEntrada = await TipoEntradaService.getAllTipoEntrada().then( rsp => rsp.data ) || [];
        },
        async getProveedores(){
            this.proveedores = await ProveedorDataService.allProveedor().then( rsp => rsp.data ) || [];
        },
        async getAllTipoPago(){
            this.tipoPagos = await TipoPagoDataService.allTipoPago().then( rsp => rsp.data ) || [];
        },
        async getMoneda(){
            this.monedas = await MonedaDataService.getAllTipoMoneda().then( resp => resp.data ) || [];
        },
        async getAllProducto(){
            this.productos = await ProductoDataService.findAll().then( rsp => rsp.data ) || [];
        },
        handleModal(){
            this.dialog = !this.dialog;
        },
        checkIfHasSucursal(){
            if(!this.hasSucursal){
                this.$swal.fire({ icon: 'info', title: 'Asigna una sucursal', text: 'Favor de asignar una sucursal a tu usuario', showConfirmButton: false, timer: 3500 });
                return;
            }
            this.mode = 'add';
            this.entradaId = null;
            this.handleModal();
        },
        handleExcelExport(){ this.dialogEntryReportExcel = !this.dialogEntryReportExcel },
    },

    computed: {

        // Filtros dinámicos: el mixin los manda al backend y
        // resetea la página a 1 cuando cambian.
        // Los vacíos van como undefined: axios no los manda y el backend
        // usa sus defaults.
        tableFilters() {
            return {
                startDate: this.datesRange.start,
                endDate: this.datesRange.end,
                providerId: this.filterProviderId || undefined,
                typeEntry: this.filterPending ? 'pending' : undefined,
                showInventory: this.filterInventory || undefined,
                ...advancedParams(this.advanced)
            };
        },
        advancedCount() { return countAdvanced(this.advanced); },
        // Nombres para los chips de los filtros del panel.
        filterCatalogs() {
            return { products: this.productos, sucursales: this.sucursales, tipoEntrada: this.tipoEntrada };
        },
        routeFilters() {
            return JSON.stringify([this.proveedorId, this.typeEntry, this.showInventory]);
        },
        titleModule(){
            return this.showInventory ? 'Inventario' : 'Entradas';
        },
        headerIcon(){
            return this.showInventory ? 'fas fa-warehouse' : 'fas fa-cart-arrow-down';
        },
        headerHelp(){
            return this.showInventory
                ? 'Lotes con existencia disponible. Para dar de alta mercancía ve a Entradas.'
                : 'Compras, traspasos y procesos que ingresan inventario. Cada fila es un lote: su existencia baja con las ventas, traspasos y mermas.';
        },
        filterTipoEntrada() { return this.tipoEntrada.filter( te => te.id !== 3 ); },
        filteredHeaders() { return this.headers.filter(h => h.show); },
        hasSucursal(){
            const sucursal = SucursalDataService.getCurrentSucursal();
            return sucursal != undefined || sucursal != null;
        },
        isAdmin(){ return can(CAP.ADMIN, UsuarioDataService.getUserRoles()); },
        // Quien solo ve su sucursal no necesita filtrar por sucursal.
        canFilterSucursal(){ return can(CAP.SUCURSAL_TODAS_VER, UsuarioDataService.getUserRoles()); },
    }
}
</script>
<style scoped>
/* Columns.vue trae mt-5 ml-2 fijos y un icono grande en primary: dentro de la
   fila de herramientas de la tabla se alinea y se iguala a sus vecinos. */
.columns-btn-fix ::v-deep .v-btn {
    margin: 0 !important;
    color: var(--app-text-muted) !important;
}
.columns-btn-fix ::v-deep .v-btn .v-icon {
    font-size: 16px;
    color: inherit;
}
/* celular: los tres iconos de la tabla llegan a 40px para poder tocarlos */
@media (max-width: 599px) {
    .columns-btn-fix ::v-deep .v-btn {
        width: 40px;
        height: 40px;
    }
}
</style>